<template>
  <div id="app">
    <div id="content" class="flex-grow-1 bg-light container-fluid p-4 d-flex flex-column" v-if="data !== null" >
      <nav class="d-flex justify-content-between align-items-center mb-4">
        <h3 class="d-flex h3 mb-0 align-items-center">
          <Logo :fill="'#007bff'" :height="'33px'" :width="'33px'" class="mb-0 mr-2 d-flex align-items-center"></Logo>
          Trademaster4Reseller
        </h3>
        <b-input placeholder="Suchen" v-model="filter" class="mx-5 w-25"></b-input>
        <small class="text-right whitespace-no-wrap">Letzte Akt.: {{data.update.date}} {{data.update.time}} Uhr</small>
      </nav>
      <b-card no-body class="flex-grow-1">
        <TableComponent :tableDataArray="data.tableData" :filter="filter"></TableComponent>
      </b-card>
    </div>
    
    <div id="loader" v-else>
      <b-spinner label="Spinning"></b-spinner>
      <div class="mt-2">Bitte warten</div>
    </div>
  </div>
</template>

<script>
import Logo from './components/Logo.vue'
import TableComponent from './components/TableComponent.vue'

import { db } from './plugins/firebase'
import { onValue, ref } from "firebase/database"

export default {
  name: 'App',
  components: {
    Logo,
    TableComponent
  },
  data() {
    return {
      data: {
        tableData: null,
        update: {
          time: null,
          date: null
        }
      },
      filter: ''
    }
  },
  methods: {
    fetchData(){
      onValue(ref(db, 'update/'), (snapshot) => {
        this.data.update = snapshot.val()
        return 
      })
      onValue(ref(db, 'tableData/'), (snapshot) => {
        this.data.tableData = snapshot.val()
        return 
      })
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>

<style scoped>
#app {
  margin: 0px !important;
  flex-grow: 1;
  display: flex;
}
#loader {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.whitespace-no-wrap {
  white-space: nowrap;
}
.card {
  overflow: hidden;
}
</style>